import { render, staticRenderFns } from "./HeaderPortada.vue?vue&type=template&id=da829dd4&"
import script from "./HeaderPortada.vue?vue&type=script&lang=js&"
export * from "./HeaderPortada.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPortada.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports